module.exports = __webpack_public_path__ + "img/5.5ef25781.jpg";